import { unwrapResult } from "@reduxjs/toolkit";
import { useAppDispatch } from "model";
import { getMetabaseUrl } from "model/metabaseUrlSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MetabaseIframe } from "./MetabaseIframe";

export function AccessibleFarmsInsights() {
  const selectedAccessibleFarmerDashboard = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    (state) => (state as any).selectedAccessibleFarmerDashboard
  );

  const selectedAccessibleFarmer = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    (state) => (state as any).selectedAccessibleFarmer
  );
  const dispatch = useAppDispatch();
  const [metabaseUrl, setMetabaseUrl] = useState<string>("");
  useEffect(() => {
    if (
      selectedAccessibleFarmerDashboard &&
      selectedAccessibleFarmerDashboard.guid
    ) {
      const workaroundFunc = async () => {
        if (!selectedAccessibleFarmer?.guid) {
          return;
        }
        const params: { [name: string]: string } = {
          userFilter: selectedAccessibleFarmer?.guid ?? "",
        };
        try {
          const res = await dispatch(
            getMetabaseUrl({
              visualizationId: selectedAccessibleFarmerDashboard.guid,
              params,
            })
          ).then(unwrapResult);
          setMetabaseUrl(res.url);
        } catch (e) {
          console.log(e);
        }
      };
      void workaroundFunc();
    } else {
      setMetabaseUrl("");
    }
  }, [
    dispatch,
    selectedAccessibleFarmerDashboard?.guid,
    selectedAccessibleFarmerDashboard,
    selectedAccessibleFarmer,
    selectedAccessibleFarmer?.guid,
  ]);
  return <MetabaseIframe metabaseUrl={metabaseUrl}></MetabaseIframe>;
}
